import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import { useAuth } from '../../AuthContext';
import { userService } from '../../services/userService';

const RoleSelection = () => {
    const navigate = useNavigate();
    const { updateUserPlan } = useAuthStore();
    const { isAuthenticated, setUserRole } = useAuth();
    const [status, setStatus] = useState({ type: null, message: '' });

    useEffect(() => {
        if (!isAuthenticated) {
            navigate('/auth');
        }
    }, [navigate, isAuthenticated]);

    const handleRoleSelection = async (role) => {
        if (!isAuthenticated) {
            navigate('/auth');
            return;
        }

        if (role === 'personal') {
            try {
                await userService.updateMyRole('user');
                setUserRole('user');
                localStorage.setItem('role', 'user');
            } catch (err) {
                // Non-blocking: log; keep local role so UX continues
                console.warn('Failed to persist role=user:', err);
                setUserRole('user');
                localStorage.setItem('role', 'user');
            }
            setStatus({ type: 'success', message: 'Account created successfully. Redirecting to your dashboard...' });
            setTimeout(() => navigate('/dashboard/user'), 1200);
            try {
                await updateUserPlan(undefined, 'personal');
            } catch (err) {
                console.warn('Failed to update plan for personal role:', err);
            }
            return;
        }

        if (role === 'ecommerce') {
            try {
                await userService.updateMyRole('ecommerce');
                setUserRole('ecommerce');
                localStorage.setItem('role', 'ecommerce');
            } catch (err) {
                console.warn('Failed to persist role=ecommerce:', err);
                setUserRole('ecommerce');
                localStorage.setItem('role', 'ecommerce');
            }
            setStatus({ type: 'success', message: 'Account created successfully. Redirecting to plan selection...' });
            setTimeout(() => navigate('/auth/plan-selection'), 1200);
            return;
        }

        // Fallback
        setStatus({ type: 'error', message: 'Unknown role selected. Please try again.' });
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
            <div className="p-8 bg-white rounded-lg shadow-md w-96">
                <h2 className="mb-6 text-2xl font-bold text-center">Select Your Account Type</h2>
                {status.type === 'success' && (
                    <div className="mb-4 p-3 rounded-md bg-green-50 border border-green-200 text-green-700 text-sm">
                        {status.message}
                    </div>
                )}
                {status.type === 'error' && (
                    <div className="mb-4 p-3 rounded-md bg-red-50 border border-red-200 text-red-700 text-sm">
                        {status.message}
                    </div>
                )}
                <div className="flex flex-col space-y-4">
                    <button
                        onClick={() => handleRoleSelection('personal')}
                        className="px-4 py-2 font-semibold text-white bg-blue-500 rounded-md hover:bg-blue-600"
                    >
                        Personal
                    </button>
                    <button
                        onClick={() => handleRoleSelection('ecommerce')}
                        className="px-4 py-2 font-semibold text-white bg-green-500 rounded-md hover:bg-green-600"
                    >
                        Ecommerce
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RoleSelection;
